import {
    EXPORT_CATEGORY_SALES_REPORT_FAIL,
    EXPORT_CATEGORY_SALES_REPORT_SUCCESS,
    EXPORT_CUSTOMER_REPORT_FAIL,
    EXPORT_CUSTOMER_REPORT_SUCCESS,
    EXPORT_MARKETING_REPORT_FAIL,
    EXPORT_MARKETING_REPORT_SUCCESS,
    EXPORT_PRODUCT_SALES_REPORT_FAIL,
    EXPORT_PRODUCT_SALES_REPORT_SUCCESS,
    EXPORT_SALES_REPORT_FAIL,
    EXPORT_SALES_REPORT_SUCCESS,
    GET_CATEGORY_SALES_REPORT_FAIL,
    GET_CATEGORY_SALES_REPORT_SUCCESS,
    GET_CUSTOMER_REPORT_FAIL,
    GET_CUSTOMER_REPORT_SUCCESS,
    GET_MARKETING_REPORT_FAIL,
    GET_MARKETING_REPORT_SUCCESS,
    GET_PRODUCT_SALES_REPORT_FAIL,
    GET_PRODUCT_SALES_REPORT_SUCCESS,
    GET_SALES_REPORT_FAIL,
    GET_SALES_REPORT_SUCCESS,
    RESET_REPORT_ATTACHMENT_STATE,
    RESET_REPORT_STATE
} from "./actionTypes"

const INIT_STATE = {
    salesReportListing: [],
    salesReportDocument: [],
    productSalesListing: [],
    productSalesDocument: [],
    categorySalesListing: [],
    categorySalesDocument: [],
    customerReportListing: [],
    customerReportDocument: [],
    markettingReportListing: [],
    markettingReportDocument: [],
    error: [],
}

const Report = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SALES_REPORT_SUCCESS:
            return {
                ...state,
                salesReportListing: action.payload
            }
        case GET_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SALES_REPORT_SUCCESS:
            return {
                ...state,
                salesReportDocument: action.payload
            }
        case EXPORT_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PRODUCT_SALES_REPORT_SUCCESS:
            return {
                ...state,
                productSalesListing: action.payload
            }
        case GET_PRODUCT_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_PRODUCT_SALES_REPORT_SUCCESS:
            return {
                ...state,
                productSalesDocument: action.payload
            }
        case EXPORT_PRODUCT_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CATEGORY_SALES_REPORT_SUCCESS:
            return {
                ...state,
                categorySalesListing: action.payload
            }
        case GET_CATEGORY_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_CATEGORY_SALES_REPORT_SUCCESS:
            return {
                ...state,
                categorySalesDocument: action.payload
            }
        case EXPORT_CATEGORY_SALES_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CUSTOMER_REPORT_SUCCESS:
            return {
                ...state,
                customerReportListing: action.payload
            }
        case GET_CUSTOMER_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_CUSTOMER_REPORT_SUCCESS:
            return {
                ...state,
                customerReportDocument: action.payload
            }
        case EXPORT_CUSTOMER_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_MARKETING_REPORT_SUCCESS:
            return {
                ...state,
                markettingReportListing: action.payload
            }
        case GET_MARKETING_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_MARKETING_REPORT_SUCCESS:
            return {
                ...state,
                markettingReportDocument: action.payload
            }
        case EXPORT_MARKETING_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_REPORT_STATE:
            return {
                ...state,
                salesReportListing: [],
                salesReportDocument: [],
                productSalesListing: [],
                productSalesDocument: [],
                categorySalesListing: [],
                categorySalesDocument: [],
                customerReportListing: [],
                customerReportDocument: [],
                markettingReportListing: [],
                markettingReportDocument: [],
                error: [],
            }
        case RESET_REPORT_ATTACHMENT_STATE:
            return {
                ...state,
                salesReportDocument: [],
                productSalesDocument: [],
                categorySalesDocument: [],
                customerReportDocument: [],
                markettingReportDocument: [],
                error: [],
            }
        default:
            return state
    }
}

export default Report
